// Test IDs for the O Projektu page and its GM-editable gallery.

export const ABOUT_PAGE = {
  section: "about-page",
  heroSection: "about-hero-section",
  whatSection: "about-what-section",
  differenceSection: "about-difference-section",
  eventsSection: "about-events-section",
  gallerySection: "about-gallery-section",
  ctaSection: "about-cta-section",
};

export const GALLERY = {
  grid: "gallery-grid",
  image: "gallery-image",
  lightbox: "gallery-lightbox",
  empty: "gallery-empty",
};

export const GALLERY_ADMIN = {
  page: "gallery-admin-page",
  guard: "gallery-admin-guard",
  uploadInput: "gallery-admin-upload-input",
  captionInput: "gallery-admin-caption-input",
  addButton: "gallery-admin-add-button",
  row: "gallery-admin-row",
  moveUpButton: "gallery-admin-move-up-button",
  moveDownButton: "gallery-admin-move-down-button",
  deleteButton: "gallery-admin-delete-button",
};
